<template>
    <views>
        <nav-bar
            :title="moduleTitle"
            fixed
            @click-left="onClickLeft">
        </nav-bar>
        <loading
            v-if="loadingData"
            color="#1989fa">
        </loading>
        <views
            v-else
            class="detail">
            <views class="detail-name pd" :class="{'pd': isCollect}">{{ detail.name }}</views>
            <views class="detail-time">{{ detail.created_at }}</views>
            <views class="collect" @click="collectArticle">
                <images :src="detail.collected ? collectedIcon : collectIcon"></images>
            </views>
            <views
                v-html="detail.detail_body"
                class="detail-content">
            </views>
        </views>
    </views>
</template>

<script>
import NavBar from '@/components/navBar'
import Loading from '@/components/loading'
import api from '@/utils/api'
import tools from '@/mixins/tools'
import share from '@/mixins/share'
export default {
    mixins: [tools, share],
    components: {
        Loading,
        NavBar
    },
    data() {
        return {
            detail: {
                collected: false
            },
            loadingData: false,
            collectIcon: require('@/assets/images/collect.png'),
            collectedIcon: require('@/assets/images/collect_o.png')
        }
    },
    computed: {
        query() {
            return this.$route.query
        },
        moduleTitle() {
            return this.query.name
        },
        isCollect() {
            return this.detail.collected
        }
    },
    watch: {
        'query.id': {
            handler(n, o) {
                if (n) this.getArticleDetail(n)
            },
            immediate: true
        },
        detail: {
            handler(n, o) {
                if (n && n.introduce) {
                    // this.share({
                    //     title: this.detail.name,
                    //     desc: this.detail.introduce.substring(0, 30),
                    //     link: window.location.href
                    // })
                }
            },
            immediate: true
        }
    },
    methods: {
        // 收藏
        onCollect(id) {
            console.log(id)
        },
        onClickLeft() {
            if (this.$route.query.src === 'person') {
                this.back()
            } else {
                this.push('/article')
            }
        },
        shareSuccess() {
            // alert(this.a)
        },
        shareCancel() {
            // alert(this.b)
        },
        collectArticle() {
            const params = {
                id: this.query.id,
                is_collect: !this.detail.collected
            }
            api.collectArticle(params).then((res) => {
                if (this.detail.collected) {
                    this.sucMsg('取消收藏')
                } else {
                    this.sucMsg('收藏成功')
                }
                this.detail.collected = res.data.is_collect
            })
        },
        getArticleDetail(id) {
            this.loadingData = true
            api.getArticleDetail({ id }).then((res) => {
                this.detail = res.data.info
                this.loadingData = false
            }).catch(() => {
                this.loadingData = false
            })
        }
    }
}
</script>

<style lang="scss">
@import './index.scss';
</style>
